import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  const navLinks = [{
    name: 'Sobre Nosotros',
    href: '#sobre-nosotros'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Galería',
    href: '#galeria'
  }, {
    name: 'Academia',
    href: '#academia'
  }, {
    name: 'Sucursales',
    href: '#sucursales'
  }, {
    name: 'Horarios',
    href: '#horarios'
  }];
  const closeMenu = () => setIsMobileMenuOpen(false);
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-dark py-3 shadow-lg shadow-black/50 border-b border-white/5' : 'bg-transparent py-5'}`} data-id="element-150">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
          <div className="flex justify-between items-center" data-id="element-152">
            {/* Logo */}
            <a href="#" className="flex items-center gap-3 relative z-[60]" onClick={closeMenu} data-id="element-153">
              <img src="https://cdn.magicpatterns.com/uploads/2t1zJp6PAikQXJQD9A85yD/Logo.png" alt="Luciano Barber Shop Logo" className="h-12 w-auto object-contain" data-id="element-154" />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8" data-id="element-155">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-gray-300 hover:text-gold transition-colors text-sm font-medium tracking-wide" data-id="element-156">
                  {link.name}
                </a>)}
              <a href="https://wa.me/59893472053" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-gold transition-colors text-sm font-medium tracking-wide" data-id="element-157">
                WhatsApp
              </a>
              <a href="https://lucianobarbershop.setmore.com/" target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-light text-dark font-semibold py-2.5 px-6 rounded-full transition-all duration-300 transform hover:scale-105 shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-158">
                Reservar turno
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button className="md:hidden text-white p-2 relative z-[60] hover:text-gold transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} data-id="element-159">
              {isMobileMenuOpen ? <X size={28} data-id="element-160" /> : <Menu size={28} data-id="element-161" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay - solid background, full screen */}
      <div className={`fixed inset-0 bg-dark z-40 md:hidden transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} aria-hidden={!isMobileMenuOpen} data-id="element-162">
        <div className="flex flex-col h-full pt-24 pb-8 px-6 overflow-y-auto" data-id="element-163">
          <nav className="flex flex-col gap-2 w-full" data-id="element-164">
            {navLinks.map((link, index) => <a key={link.name} href={link.href} onClick={closeMenu} className={`text-xl font-medium text-white hover:text-gold transition-all py-4 px-4 border-b border-white/5 ${isMobileMenuOpen ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-0'}`} style={{
            transitionDelay: isMobileMenuOpen ? `${index * 60}ms` : '0ms',
            transitionDuration: '400ms'
          }} data-id="element-165">
                {link.name}
              </a>)}
            <a href="https://wa.me/59893472053" target="_blank" rel="noopener noreferrer" onClick={closeMenu} className={`text-xl font-medium text-white hover:text-gold transition-all py-4 px-4 border-b border-white/5 ${isMobileMenuOpen ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-0'}`} style={{
            transitionDelay: isMobileMenuOpen ? `${navLinks.length * 60}ms` : '0ms',
            transitionDuration: '400ms'
          }} data-id="element-166">
              WhatsApp Cursos
            </a>
          </nav>

          {/* CTA at bottom */}
          <div className="mt-auto pt-8" data-id="element-167">
            <a href="https://lucianobarbershop.setmore.com/" target="_blank" rel="noopener noreferrer" onClick={closeMenu} className="block bg-gold text-dark font-bold py-4 px-8 rounded-full w-full text-center text-lg shadow-[0_0_20px_rgba(201,168,76,0.4)]" data-id="element-168">
              Reservar turno
            </a>
          </div>
        </div>
      </div>
    </>;
}